export const FIELD_TYPES = {
  INPUT: 'INPUT',
  SELECT: 'SELECT',
  AUTOCOMPLETE: 'AUTOCOMPLETE',
  DATE_PICKER: 'DATE_PICKER',
};

export const UID_CONSTANTS = {
  DESTINATION_AUTOCOMPLETE: 'DESTINATION_AUTOCOMPLETE',
  CHECKIN_CHECKOUT_DATEPICKER: 'CHECKIN_CHECKOUT_DATEPICKER',
  CHECKIN_DATE_DATEPICKER: 'CHECKIN_DATE_DATEPICKER',
  CHECKIN_DATE_DATEPICKER_DISPLAY: 'CHECKIN_DATE_DATEPICKER_DISPLAY',
  CHECKIN_CHECKOUT_DATEPICKER_DISPLAY: 'CHECKIN_CHECKOUT_DATEPICKER_DISPLAY',
  CHECKIN_TIME: 'CHECKIN_TIME',
  HOUR: 'HOUR',
  NEW_ROOM_GUEST_PICKER: 'NEW_ROOM_GUEST_PICKER',
  NEW_GUEST_PICKER: 'NEW_GUEST_PICKER',
  PRICE_FILTER: 'PRICE_FILTER',
  POPULAR_FILTER: 'POPULAR_FILTER',
  USER_RATING_FILTER: 'USER_RATING_FILTER',
  STAR_RATING: 'STAR_RATING',
  PROPERTY_CATEGORY: 'PROPERTY_CATEGORY',
  FACILITY: 'FACILITY',
  LOCALITY_FILTERS: 'LOCALITY_FILTERS',
};

export const FEATURE_CONSTANTS = {
  EXPERIENCES: 'EXPERIENCES',
};
